import { controlledDevices } from '~/helpers/fields-description';
import { Endpoint } from '~/interfaces/device.interface';
import { LegrandModule } from './LegrandModule.model';

export class NLOC extends LegrandModule {

    isWired = true;
    endpoints: Endpoint[] = [];

    get fieldControlledDevices() {
        return controlledDevices(this.controlledDevice(0));
    }

    get controlledDevice() {
        return (button: number) => {
            return (typeof this.endpoints !== 'undefined' && typeof this.endpoints[button] !== 'undefined') ?
                this.endpoints[button].bindings : undefined;
        };
    }

}
